// components/AuthorList.js
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { SearchContext } from '../App';

function AuthorList() {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  
  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const response = await api.getAuthors();
        setAuthors(response);
        setLoading(false);
      } catch (err) {
        setError('Failed to load authors');
        setLoading(false);
      }
    };

    fetchAuthors();
  }, []);

  // Filter authors based on search term
  const filteredAuthors = authors.filter(author =>
    author.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="loading">ავტორები იტვირთება...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="author-list">
      <div className="search-container">
        <input
          type="text"
          placeholder="მოძებნე ავტორი..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      <h2>ავტორები</h2>
      <div className="author-grid">
        {filteredAuthors.map(author => (
          <Link 
            to={`/author/${author.id}`} 
            key={author.id} 
            className="author-card"
          >
            <div className="author-image">
              <img src={`/images/authors/${author.id}.jpg`} alt={author.name} onError={(e) => {e.target.src = '/images/default-author.jpg'}} />
            </div>
            <h3>{author.name}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default AuthorList;